import Image from "next/image";
import styled from "styled-components";
import { tragetableFallbackImg } from "../../../config";

type Props = {
  className?: string;
  width?: number;
  height?: number;
};

const TitleLogo = ({ className, width = 86, height = 86 }: Props) => {
  return (
    <StyledLogo width={width} height={height} className={`${className || ""}`}>
      <Image
        unoptimized
        className="d-block img-thumbnail rounded-circle object-fit-cover mx-auto"
        width={width}
        height={height}
        src={tragetableFallbackImg}
        alt="molham-logo"
      />
    </StyledLogo>
  );
};

export default TitleLogo;
const StyledLogo = styled.div<{ width: number; height: number }>`
  img {
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
  }
  @media (max-width: 767.98px) {
    img {
      width: 56px;
      height: 56px;
    }
  }
`;
